import { FC } from "react";
import { useLocation } from "react-router-dom";

import { useAppContext } from "web/context/app";

import DesktopMainHeader from "./Desktop";
import MobileMainHeader from "./Mobile";
import { hiddenHeaderDesktopPathNames } from "./headerPaths";

const MainHeader: FC = () => {
  const { pathname } = useLocation();
  const { isMobile } = useAppContext();

  if (
    !isMobile &&
    hiddenHeaderDesktopPathNames.some((path) => !pathname.indexOf(path))
  ) {
    return null;
  }

  if (isMobile) {
    return <MobileMainHeader />;
  }

  return <DesktopMainHeader />;
};

export default MainHeader;
